export const SEND_EVENT_DATA = "SEND_EVENT_DATA";
export const ADD_EVENT_DATA = "ADD_EVENT_DATA";


// WEBPACK FOOTER //
// ./src/reducers/actions.js